const fancyTextStyles = [
    // Mathematical Script

   
    
    // Example usage:
    // transformText('hello', 'zalgo') => "h̶͠͝ë̷́̅l̶̿͝l̶̿͝ö̸́͝"
    // transformText('abc', 'chess') => "🨀🨁🨂"
    text => text.split('').map(char => {
        const map = {
            'a': '𝓪', 'b': '𝓫', 'c': '𝓬', 'd': '𝓭', 'e': '𝓮',
            'f': '𝓯', 'g': '𝓰', 'h': '𝓱', 'i': '𝓲', 'j': '𝓳',
            'k': '𝓴', 'l': '𝓵', 'm': '𝓶', 'n': '𝓷', 'o': '𝓸',
            'p': '𝓹', 'q': '𝓺', 'r': '𝓻', 's': '𝓼', 't': '𝓽',
            'u': '𝓾', 'v': '𝓿', 'w': '𝔀', 'x': '𝔁', 'y': '𝔂',
            'z': '𝔃'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),
    
    // Greek Letters
   

    // Sans-Serif Bold
    text => text.split('').map(char => {
        const map = {
            'a': '𝗮', 'b': '𝗯', 'c': '𝗰', 'd': '𝗱', 'e': '𝗲',
            'f': '𝗳', 'g': '𝗴', 'h': '𝗵', 'i': '𝗶', 'j': '𝗷',
            'k': '𝗸', 'l': '𝗹', 'm': '𝗺', 'n': '𝗻', 'o': '𝗼',
            'p': '𝗽', 'q': '𝗾', 'r': '𝗿', 's': '𝘀', 't': '𝘁',
            'u': '𝘂', 'v': '𝘃', 'w': '𝘄', 'x': '𝘅', 'y': '𝘆',
            'z': '𝘇'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),

    // Sans-Serif Italic
    text => text.split('').map(char => {
        const map = {
            'a': '𝘢', 'b': '𝘣', 'c': '𝘤', 'd': '𝘥', 'e': '𝘦',
            'f': '𝘧', 'g': '𝘨', 'h': '𝘩', 'i': '𝘪', 'j': '𝘫',
            'k': '𝘬', 'l': '𝘭', 'm': '𝘮', 'n': '𝘯', 'o': '𝘰',
            'p': '𝘱', 'q': '𝘲', 'r': '𝘳', 's': '𝘴', 't': '𝘵',
            'u': '𝘶', 'v': '𝘷', 'w': '𝘸', 'x': '𝘹', 'y': '𝘺',
            'z': '𝘻'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),

    // Sans-Serif Bold Italic
    text => text.split('').map(char => {
        const map = {
            'a': '𝙖', 'b': '𝙗', 'c': '𝙘', 'd': '𝙙', 'e': '𝙚',
            'f': '𝙛', 'g': '𝙜', 'h': '𝙝', 'i': '𝙞', 'j': '𝙟',
            'k': '𝙠', 'l': '𝙡', 'm': '𝙢', 'n': '𝙣', 'o': '𝙤',
            'p': '𝙥', 'q': '𝙦', 'r': '𝙧', 's': '𝙨', 't': '𝙩',
            'u': '𝙪', 'v': '𝙫', 'w': '𝙬', 'x': '𝙭', 'y': '𝙮',
            'z': '𝙯'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),

    // Monospace
    text => text.split('').map(char => {
        const map = {
            'a': '𝚊', 'b': '𝚋', 'c': '𝚌', 'd': '𝚍', 'e': '𝚎',
            'f': '𝚏', 'g': '𝚐', 'h': '𝚑', 'i': '𝚒', 'j': '𝚓',
            'k': '𝚔', 'l': '𝚕', 'm': '𝚖', 'n': '𝚗', 'o': '𝚘',
            'p': '𝚙', 'q': '𝚚', 'r': '𝚛', 's': '𝚜', 't': '𝚝',
            'u': '𝚞', 'v': '𝚟', 'w': '𝚠', 'x': '𝚡', 'y': '𝚢',
            'z': '𝚣'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),

    // Script Bold
    text => text.split('').map(char => {
        const map = {
            'a': '𝓪', 'b': '𝓫', 'c': '𝓬', 'd': '𝓭', 'e': '𝓮',
            'f': '𝓯', 'g': '𝓰', 'h': '𝓱', 'i': '𝓲', 'j': '𝓳',
            'k': '𝓴', 'l': '𝓵', 'm': '𝓶', 'n': '𝓷', 'o': '𝓸',
            'p': '𝓹', 'q': '𝓺', 'r': '𝓻', 's': '𝓼', 't': '𝓽',
            'u': '𝓾', 'v': '𝓿', 'w': '𝔀', 'x': '𝔁', 'y': '𝔂',
            'z': '𝔃'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),

    // Gothic
    text => text.split('').map(char => {
        const map = {
            'a': '𝔄', 'b': '𝔅', 'c': 'ℭ', 'd': '𝔇', 'e': '𝔈',
            'f': '𝔉', 'g': '𝔊', 'h': 'ℌ', 'i': 'ℑ', 'j': '𝔍',
            'k': '𝔎', 'l': '𝔏', 'm': '𝔐', 'n': '𝔑', 'o': '𝔒',
            'p': '𝔓', 'q': '𝔔', 'r': 'ℜ', 's': '𝔖', 't': '𝔗',
            'u': '𝔘', 'v': '𝔙', 'w': '𝔚', 'x': '𝔛', 'y': '𝔜',
            'z': 'ℨ'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),

    // Regional Indicators (Country flags style)
    text => text.split('').map(char => {
        const map = {
            'a': '🇦', 'b': '🇧', 'c': '🇨', 'd': '🇩', 'e': '🇪',
            'f': '🇫', 'g': '🇬', 'h': '🇭', 'i': '🇮', 'j': '🇯',
            'k': '🇰', 'l': '🇱', 'm': '🇲', 'n': '🇳', 'o': '🇴',
            'p': '🇵', 'q': '🇶', 'r': '🇷', 's': '🇸', 't': '🇹',
            'u': '🇺', 'v': '🇻', 'w': '🇼', 'x': '🇽', 'y': '🇾',
            'z': '🇿'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),

    // Superscript
    text => text.split('').map(char => {
        const map = {
            'a': 'ᵃ', 'b': 'ᵇ', 'c': 'ᶜ', 'd': 'ᵈ', 'e': 'ᵉ',
            'f': 'ᶠ', 'g': 'ᵍ', 'h': 'ʰ', 'i': 'ⁱ', 'j': 'ʲ',
            'k': 'ᵏ', 'l': 'ˡ', 'm': 'ᵐ', 'n': 'ⁿ', 'o': 'ᵒ',
            'p': 'ᵖ', 'q': 'ᵠ', 'r': 'ʳ', 's': 'ˢ', 't': 'ᵗ',
            'u': 'ᵘ', 'v': 'ᵛ', 'w': 'ʷ', 'x': 'ˣ', 'y': 'ʸ',
            'z': 'ᶻ',
            '0': '⁰', '1': '¹', '2': '²', '3': '³', '4': '⁴',
            '5': '⁵', '6': '⁶', '7': '⁷', '8': '⁸', '9': '⁹'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),

    // Subscript
    text => text.split('').map(char => {
        const map = {
            'a': 'ₐ', 'b': 'ᵦ', 'c': '꜀', 'd': 'ᑯ', 'e': 'ₑ',
            'f': 'բ', 'g': '₉', 'h': 'ₕ', 'i': 'ᵢ', 'j': 'ⱼ',
            'k': 'ₖ', 'l': 'ₗ', 'm': 'ₘ', 'n': 'ₙ', 'o': 'ₒ',
            'p': 'ₚ', 'q': '૧', 'r': 'ᵣ', 's': 'ₛ', 't': 'ₜ',
            'u': 'ᵤ', 'v': 'ᵥ', 'w': 'w', 'x': 'ₓ', 'y': 'ᵧ',
            'z': '₂',
            '0': '₀', '1': '₁', '2': '₂', '3': '₃', '4': '₄',
            '5': '₅', '6': '₆', '7': '₇', '8': '₈', '9': '₉'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),

    // Zalgo
    text => text.split('').map(char => {
        const map = {
            'a': 'a̸͋͐', 'b': 'b̴͠͝', 'c': 'c̷̓̽', 'd': 'd̵̽̕', 'e': 'ë̷́̅',
            'f': 'f̴͋̕', 'g': 'g̸̈́̔', 'h': 'ḧ̶́͝', 'i': 'i̵̕͝', 'j': 'j̴̈́͝',
            'k': 'k̵̔͝', 'l': 'l̶̿͝', 'm': 'm̴̈́͝', 'n': 'n̵̈́͝', 'o': 'ö̸́͝',
            'p': 'p̴̈́͝', 'q': 'q̵̈́͝', 'r': 'r̴̈́͝', 's': 's̵̈́͝', 't': 'ẗ̴́͝',
            'u': 'ǘ̵͝', 'v': 'v̴̈́͝', 'w': 'ẅ̵́͝', 'x': 'ẍ̴́͝', 'y': 'ÿ̵́͝',
            'z': 'z̴̈́͝'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),

    // Strikethrough
    text => text.split('').map(char => {
        const map = {
            'a': 'a̶', 'b': 'b̶', 'c': 'c̶', 'd': 'd̶', 'e': 'e̶',
            'f': 'f̶', 'g': 'g̶', 'h': 'h̶', 'i': 'i̶', 'j': 'j̶',
            'k': 'k̶', 'l': 'l̶', 'm': 'm̶', 'n': 'n̶', 'o': 'o̶',
            'p': 'p̶', 'q': 'q̶', 'r': 'r̶', 's': 's̶', 't': 't̶',
            'u': 'u̶', 'v': 'v̶', 'w': 'w̶', 'x': 'x̶', 'y': 'y̶',
            'z': 'z̶'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),

    // Underline
    text => text.split('').map(char => {
        const map = {
            'a': 'a̲', 'b': 'b̲', 'c': 'c̲', 'd': 'd̲', 'e': 'e̲',
            'f': 'f̲', 'g': 'g̲', 'h': 'h̲', 'i': 'i̲', 'j': 'j̲',
            'k': 'k̲', 'l': 'l̲', 'm': 'm̲', 'n': 'n̲', 'o': 'o̲',
            'p': 'p̲', 'q': 'q̲', 'r': 'r̲', 's': 's̲', 't': 't̲',
            'u': 'u̲', 'v': 'v̲', 'w': 'w̲', 'x': 'x̲', 'y': 'y̲',
            'z': 'z̲'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),

    // Dotted
    text => text.split('').map(char => {
        const map = {
            'a': 'ạ', 'b': 'ḅ', 'c': 'c̣', 'd': 'ḍ', 'e': 'ẹ',
            'f': 'f̣', 'g': 'g̣', 'h': 'ḥ', 'i': 'ị', 'j': 'j̣',
            'k': 'ḳ', 'l': 'ḷ', 'm': 'ṃ', 'n': 'ṇ', 'o': 'ọ',
            'p': 'p̣', 'q': 'q̣', 'r': 'ṛ', 's': 'ṣ', 't': 'ṭ',
            'u': 'ụ', 'v': 'ṿ', 'w': 'ẉ', 'x': 'x̣', 'y': 'ỵ',
            'z': 'ẓ'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),

    // Overline
    text => text.split('').map(char => {
        const map = {
            'a': 'a̅', 'b': 'b̅', 'c': 'c̅', 'd': 'd̅', 'e': 'e̅',
            'f': 'f̅', 'g': 'g̅', 'h': 'h̅', 'i': 'i̅', 'j': 'j̅',
            'k': 'k̅', 'l': 'l̅', 'm': 'm̅', 'n': 'n̅', 'o': 'o̅',
            'p': 'p̅', 'q': 'q̅', 'r': 'r̅', 's': 's̅', 't': 't̅',
            'u': 'u̅', 'v': 'v̅', 'w': 'w̅', 'x': 'x̅', 'y': 'y̅',
            'z': 'z̅'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),

    // Wavy
    text => text.split('').map(char => {
        const map = {
            'a': 'a̰', 'b': 'b̰', 'c': 'c̰', 'd': 'd̰', 'e': 'ḛ',
            'f': 'f̰', 'g': 'g̰', 'h': 'h̰', 'i': 'ḭ', 'j': 'j̰',
            'k': 'k̰', 'l': 'l̰', 'm': 'm̰', 'n': 'n̰', 'o': 'o̰',
            'p': 'p̰', 'q': 'q̰', 'r': 'r̰', 's': 's̰', 't': 't̰',
            'u': 'ṵ', 'v': 'v̰', 'w': 'w̰', 'x': 'x̰', 'y': 'y̰',
            'z': 'z̰'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),

    // Math Bold
    text => text.split('').map(char => {
        const map = {
            'a': '𝖆', 'b': '𝖇', 'c': '𝖈', 'd': '𝖉', 'e': '𝖊',
            'f': '𝖋', 'g': '𝖌', 'h': '𝖍', 'i': '𝖎', 'j': '𝖏',
            'k': '𝖐', 'l': '𝖑', 'm': '𝖒', 'n': '𝖓', 'o': '𝖔',
            'p': '𝖕', 'q': '𝖖', 'r': '𝖗', 's': '𝖘', 't': '𝖙',
            'u': '𝖚', 'v': '𝖛', 'w': '𝖜', 'x': '𝖝', 'y': '𝖞',
            'z': '𝖟'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),

    // Math Script
    text => text.split('').map(char => {
        const map = {
            'a': '𝒶', 'b': '𝒷', 'c': '𝒸', 'd': '𝒹', 'e': 'ℯ',
            'f': '𝒻', 'g': 'ℊ', 'h': '𝒽', 'i': '𝒾', 'j': '𝒿',
            'k': '𝓀', 'l': '𝓁', 'm': '𝓂', 'n': '𝓃', 'o': 'ℴ',
            'p': '𝓅', 'q': '𝓆', 'r': '𝓇', 's': '𝓈', 't': '𝓉',
            'u': '𝓊', 'v': '𝓋', 'w': '𝓌', 'x': '𝓍', 'y': '𝓎',
            'z': '𝓏'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),

    // Inverted
    text => text.split('').map(char => {
        const map = {
            'a': '🅰', 'b': '🅱', 'c': '🅲', 'd': '🅳', 'e': '🅴',
            'f': '🅵', 'g': '🅶', 'h': '🅷', 'i': '🅸', 'j': '🅹',
            'k': '🅺', 'l': '🅻', 'm': '🅼', 'n': '🅽', 'o': '🅾',
            'p': '🅿', 'q': '🆀', 'r': '🆁', 's': '🆂', 't': '🆃',
            'u': '🆄', 'v': '🆅', 'w': '🆆', 'x': '🆇', 'y': '🆈',
            'z': '🆉'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),

    // Currency
    text => text.split('').map(char => {
        const map = {
            'a': '₳', 'b': '฿', 'c': '₵', 'd': 'Đ', 'e': 'Ɇ',
            'f': '₣', 'g': '₲', 'h': 'Ⱨ', 'i': 'ł', 'j': 'J',
            'k': '₭', 'l': 'Ⱡ', 'm': '₥', 'n': '₦', 'o': 'Ø',
            'p': '₱', 'q': 'Q', 'r': 'Ɽ', 's': '₴', 't': '₮',
            'u': 'Ʉ', 'v': 'V', 'w': '₩', 'x': 'Ӿ', 'y': 'Ɏ',
            'z': 'Ⱬ'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),

    // Ancient
    text => text.split('').map(char => {
        const map = {
            'a': '𐌀', 'b': '𐌁', 'c': '𐌂', 'd': '𐌃', 'e': '𐌄',
            'f': '𐌅', 'g': '𐌆', 'h': '𐌇', 'i': '𐌉', 'j': '𐌉',
            'k': '𐌊', 'l': '𐌋', 'm': '𐌌', 'n': '𐌍', 'o': '𐌏',
            'p': '𐌐', 'q': '𐌒', 'r': '𐌓', 's': '𐌔', 't': '𐌕',
            'u': '𐌖', 'v': '𐌖', 'w': '𐌖𐌖', 'x': '𐌗', 'y': '𐌘',
            'z': '𐌆'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),

    // Runic
    text => text.split('').map(char => {
        const map = {
            'a': 'ᚨ', 'b': 'ᛒ', 'c': 'ᚲ', 'd': 'ᛞ', 'e': 'ᛖ',
            'f': 'ᚠ', 'g': 'ᚷ', 'h': 'ᚺ', 'i': 'ᛁ', 'j': 'ᛃ',
            'k': 'ᚲ', 'l': 'ᛚ', 'm': 'ᛗ', 'n': 'ᚾ', 'o': 'ᛟ',
            'p': 'ᛈ', 'q': 'ᚲ', 'r': 'ᚱ', 's': 'ᛋ', 't': 'ᛏ',
            'u': 'ᚢ', 'v': 'ᚢ', 'w': 'ᚹ', 'x': 'ᛪ', 'y': 'ᛁ',
            'z': 'ᛉ'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),

    // Hieroglyphs
    text => text.split('').map(char => {
        const map = {
            'a': '𓄿', 'b': '𓃀', 'c': '𓎡', 'd': '𓂧', 'e': '𓇌',
            'f': '𓆑', 'g': '𓎼', 'h': '𓎛', 'i': '𓇋', 'j': '𓆓',
            'k': '𓎡', 'l': '𓃭', 'm': '𓅓', 'n': '𓈖', 'o': '𓄿',
            'p': '𓊪', 'q': '𓎡', 'r': '𓂋', 's': '𓋴', 't': '𓏏',
            'u': '𓅱', 'v': '𓃀', 'w': '𓅱', 'x': '𓎡', 'y': '𓇋',
            'z': '𓊃'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),

    // Alchemical
    text => text.split('').map(char => {
        const map = {
            'a': '🜁', 'b': '🜂', 'c': '🜃', 'd': '🜄', 'e': '🜅',
            'f': '🜆', 'g': '🜇', 'h': '🜈', 'i': '🜉', 'j': '🜊',
            'k': '🜋', 'l': '🜌', 'm': '🜍', 'n': '🜎', 'o': '🜏',
            'p': '🜐', 'q': '🜑', 'r': '🜒', 's': '🜓', 't': '🜔',
            'u': '🜕', 'v': '🜖', 'w': '🜗', 'x': '🜘', 'y': '🜙',
            'z': '🜚'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),

    // Chess
    text => text.split('').map(char => {
        const map = {
            'a': '🨀', 'b': '🨁', 'c': '🨂', 'd': '🨃', 'e': '🨄',
            'f': '🨅', 'g': '🨆', 'h': '🨇', 'i': '🨈', 'j': '🨉',
            'k': '🨊', 'l': '🨋', 'm': '🨌', 'n': '🨍', 'o': '🨎',
            'p': '🨏', 'q': '🨐', 'r': '🨑', 's': '🨒', 't': '🨓',
            'u': '🨔', 'v': '🨕', 'w': '🨖', 'x': '🨗', 'y': '🨘',
            'z': '🨙'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),
    text => text.split('').map(char => {
        const map = {
            'a': 'α', 'b': 'β', 'c': 'ς', 'd': 'δ', 'e': 'ε',
            'f': 'φ', 'g': 'γ', 'h': 'η', 'i': 'ι', 'j': 'ξ',
            'k': 'κ', 'l': 'λ', 'm': 'μ', 'n': 'ν', 'o': 'ο',
            'p': 'π', 'q': 'θ', 'r': 'ρ', 's': 'σ', 't': 'τ',
            'u': 'υ', 'v': 'ω', 'w': 'ω', 'x': 'χ', 'y': 'ψ',
            'z': 'ζ'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),
    
    // Cyrillic Letters
    text => text.split('').map(char => {
        const map = {
            'a': 'а', 'b': 'б', 'c': 'ц', 'd': 'д', 'e': 'е',
            'f': 'ф', 'g': 'г', 'h': 'х', 'i': 'и', 'j': 'й',
            'k': 'к', 'l': 'л', 'm': 'м', 'n': 'н', 'o': 'о',
            'p': 'п', 'q': 'я', 'r': 'р', 's': 'с', 't': 'т',
            'u': 'у', 'v': 'в', 'w': 'ш', 'x': 'щ', 'y': 'ы',
            'z': 'з'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),
    
    // Fancy Fonts (Fraktur)
    text => text.split('').map(char => {
        const map = {
            'a': '𝔞', 'b': '𝔟', 'c': '𝔠', 'd': '𝔡', 'e': '𝔢',
            'f': '𝔣', 'g': '𝔤', 'h': '𝔥', 'i': '𝔦', 'j': '𝔧',
            'k': '𝔨', 'l': '𝔩', 'm': '𝔪', 'n': '𝔫', 'o': '𝔬',
            'p': '𝔭', 'q': '𝔮', 'r': '𝔯', 's': '𝔰', 't': '𝔱',
            'u': '𝔲', 'v': '𝔳', 'w': '𝔴', 'x': '𝔵', 'y': '𝔶',
            'z': '𝔷'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),
    
    // Double Struck
    text => text.split('').map(char => {
        const map = {
            'a': '𝕒', 'b': '𝕓', 'c': '𝕔', 'd': '𝕕', 'e': '𝕖',
            'f': '𝕗', 'g': '𝕘', 'h': '𝕙', 'i': '𝕚', 'j': '𝕛',
            'k': '𝕜', 'l': '𝕝', 'm': '𝕞', 'n': '𝕟', 'o': '𝕠',
            'p': '𝕡', 'q': '𝕢', 'r': '𝕣', 's': '𝕤', 't': '𝕥',
            'u': '𝕦', 'v': '𝕧', 'w': '𝕨', 'x': '𝕩', 'y': '𝕪',
            'z': '𝕫'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),
    
    // Bubble Text
    text => text.split('').map(char => {
        const map = {
            'a': 'ⓐ', 'b': 'ⓑ', 'c': 'ⓒ', 'd': 'ⓓ', 'e': 'ⓔ',
            'f': 'ⓕ', 'g': 'ⓖ', 'h': 'ⓗ', 'i': 'ⓘ', 'j': 'ⓙ',
            'k': 'ⓚ', 'l': 'ⓛ', 'm': 'ⓜ', 'n': 'ⓝ', 'o': 'ⓞ',
            'p': 'ⓟ', 'q': 'ⓠ', 'r': 'ⓡ', 's': 'ⓢ', 't': 'ⓣ',
            'u': 'ⓤ', 'v': 'ⓥ', 'w': 'ⓦ', 'x': 'ⓧ', 'y': 'ⓨ',
            'z': 'ⓩ'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),
    
    // Upside Down
    text => text.split('').map(char => {
        const map = {
            'a': 'ɐ', 'b': 'q', 'c': 'ɔ', 'd': 'p', 'e': 'ǝ',
            'f': 'ɟ', 'g': 'ƃ', 'h': 'ɥ', 'i': 'ᴉ', 'j': 'ɾ',
            'k': 'ʞ', 'l': 'l', 'm': 'ɯ', 'n': 'u', 'o': 'o',
            'p': 'd', 'q': 'b', 'r': 'ɹ', 's': 's', 't': 'ʇ',
            'u': 'n', 'v': 'ʌ', 'w': 'ʍ', 'x': 'x', 'y': 'ʎ',
            'z': 'z'
        };
        return map[char.toLowerCase()] || char;
    }).join('').split('').reverse().join(''),
    
    // Small Caps
    text => text.split('').map(char => {
        const map = {
            'a': 'ᴀ', 'b': 'ʙ', 'c': 'ᴄ', 'd': 'ᴅ', 'e': 'ᴇ',
            'f': 'ꜰ', 'g': 'ɢ', 'h': 'ʜ', 'i': 'ɪ', 'j': 'ᴊ',
            'k': 'ᴋ', 'l': 'ʟ', 'm': 'ᴍ', 'n': 'ɴ', 'o': 'ᴏ',
            'p': 'ᴘ', 'q': 'ǫ', 'r': 'ʀ', 's': 'ꜱ', 't': 'ᴛ',
            'u': 'ᴜ', 'v': 'ᴠ', 'w': 'ᴡ', 'x': 'x', 'y': 'ʏ',
            'z': 'ᴢ'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),

    // Fullwidth (Japanese-style)
    text => text.split('').map(char => {
        const map = {
            'a': 'ａ', 'b': 'ｂ', 'c': 'ｃ', 'd': 'ｄ', 'e': 'ｅ',
            'f': 'ｆ', 'g': 'ｇ', 'h': 'ｈ', 'i': 'ｉ', 'j': 'ｊ',
            'k': 'ｋ', 'l': 'ｌ', 'm': 'ｍ', 'n': 'ｎ', 'o': 'ｏ',
            'p': 'ｐ', 'q': 'ｑ', 'r': 'ｒ', 's': 'ｓ', 't': 'ｔ',
            'u': 'ｕ', 'v': 'ｖ', 'w': 'ｗ', 'x': 'ｘ', 'y': 'ｙ',
            'z': 'ｚ',
            '0': '０', '1': '１', '2': '２', '3': '３', '4': '４',
            '5': '５', '6': '６', '7': '７', '8': '８', '9': '９'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),

    // Squared Text
    text => text.split('').map(char => {
        const map = {
            'a': '🄰', 'b': '🄱', 'c': '🄲', 'd': '🄳', 'e': '🄴',
            'f': '🄵', 'g': '🄶', 'h': '🄷', 'i': '🄸', 'j': '🄹',
            'k': '🄺', 'l': '🄻', 'm': '🄼', 'n': '🄽', 'o': '🄾',
            'p': '🄿', 'q': '🅀', 'r': '🅁', 's': '🅂', 't': '🅃',
            'u': '🅄', 'v': '🅅', 'w': '🅆', 'x': '🅇', 'y': '🅈',
            'z': '🅉'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),

    // Negative Squared Text
    text => text.split('').map(char => {
        const map = {
            'a': '🅰', 'b': '🅱', 'c': '🅲', 'd': '🅳', 'e': '🅴',
            'f': '🅵', 'g': '🅶', 'h': '🅷', 'i': '🅸', 'j': '🅹',
            'k': '🅺', 'l': '🅻', 'm': '🅼', 'n': '🅽', 'o': '🅾',
            'p': '🅿', 'q': '🆀', 'r': '🆁', 's': '🆂', 't': '🆃',
            'u': '🆄', 'v': '🆅', 'w': '🆆', 'x': '🆇', 'y': '🆈',
            'z': '🆉'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),

    // Circled Letters
    text => text.split('').map(char => {
        const map = {
            'a': 'Ⓐ', 'b': 'Ⓑ', 'c': 'Ⓒ', 'd': 'Ⓓ', 'e': 'Ⓔ',
            'f': 'Ⓕ', 'g': 'Ⓖ', 'h': 'Ⓗ', 'i': 'Ⓘ', 'j': 'Ⓙ',
            'k': 'Ⓚ', 'l': 'Ⓛ', 'm': 'Ⓜ', 'n': 'Ⓝ', 'o': 'Ⓞ',
            'p': 'Ⓟ', 'q': 'Ⓠ', 'r': 'Ⓡ', 's': 'Ⓢ', 't': 'Ⓣ',
            'u': 'Ⓤ', 'v': 'Ⓥ', 'w': 'Ⓦ', 'x': 'Ⓧ', 'y': 'Ⓨ',
            'z': 'Ⓩ'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),

    // Parenthesized Letters
    text => text.split('').map(char => {
        const map = {
            'a': '⒜', 'b': '⒝', 'c': '⒞', 'd': '⒟', 'e': '⒠',
            'f': '⒡', 'g': '⒢', 'h': '⒣', 'i': '⒤', 'j': '⒥',
            'k': '⒦', 'l': '⒧', 'm': '⒨', 'n': '⒩', 'o': '⒪',
            'p': '⒫', 'q': '⒬', 'r': '⒭', 's': '⒮', 't': '⒯',
            'u': '⒰', 'v': '⒱', 'w': '⒲', 'x': '⒳', 'y': '⒴',
            'z': '⒵'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),

    // Mathematical Bold
    text => text.split('').map(char => {
        const map = {
            'a': '𝐚', 'b': '𝐛', 'c': '𝐜', 'd': '𝐝', 'e': '𝐞',
            'f': '𝐟', 'g': '𝐠', 'h': '𝐡', 'i': '𝐢', 'j': '𝐣',
            'k': '𝐤', 'l': '𝐥', 'm': '𝐦', 'n': '𝐧', 'o': '𝐨',
            'p': '𝐩', 'q': '𝐪', 'r': '𝐫', 's': '𝐬', 't': '𝐭',
            'u': '𝐮', 'v': '𝐯', 'w': '𝐰', 'x': '𝐱', 'y': '𝐲',
            'z': '𝐳'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),

    // Mathematical Italic
    text => text.split('').map(char => {
        const map = {
            'a': '𝑎', 'b': '𝑏', 'c': '𝑐', 'd': '𝑑', 'e': '𝑒',
            'f': '𝑓', 'g': '𝑔', 'h': 'ℎ', 'i': '𝑖', 'j': '𝑗',
            'k': '𝑘', 'l': '𝑙', 'm': '𝑚', 'n': '𝑛', 'o': '𝑜',
            'p': '𝑝', 'q': '𝑞', 'r': '𝑟', 's': '𝑠', 't': '𝑡',
            'u': '𝑢', 'v': '𝑣', 'w': '𝑤', 'x': '𝑥', 'y': '𝑦',
            'z': '𝑧'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),

    // Mathematical Bold Italic
    text => text.split('').map(char => {
        const map = {
            'a': '𝒂', 'b': '𝒃', 'c': '𝒄', 'd': '𝒅', 'e': '𝒆',
            'f': '𝒇', 'g': '𝒈', 'h': '𝒉', 'i': '𝒊', 'j': '𝒋',
            'k': '𝒌', 'l': '𝒍', 'm': '𝒎', 'n': '𝒏', 'o': '𝒐',
            'p': '𝒑', 'q': '𝒒', 'r': '𝒓', 's': '𝒔', 't': '𝒕',
            'u': '𝒖', 'v': '𝒗', 'w': '𝒘', 'x': '𝒙', 'y': '𝒚',
            'z': '𝒛'
        };
        return map[char.toLowerCase()] || char;
    }).join(''),
];

export default fancyTextStyles;